import React from "react"
import {romanize} from "utils/utils"
import Rescuer from "components/Rescuer"
import useRescuers from "hooks/useRescuers"
import "./PendingApplication.css"

const scoreFormat = new Intl.NumberFormat('sr', {
    maximumFractionDigits: 3,
    minimumFractionDigits: 3
})

export default function PendingApplication(props) {

    const {application, onConfirm, onReject, canEdit} = props
    const {getUser, hasTag} = useRescuers()
    const rescuer = getUser(application.rescuer?.username || application.username) || application.rescuer

    if (!rescuer) return null

    return <div className="pending-row">
        <div className="pending-info">
            <Rescuer rescuer={rescuer} onClick="profile"/>
            <div className="pending-details">
                {application.score != null && rescuer.coef > 0 && <span className="score">{romanize(application.wish)} želja: {scoreFormat.format(application.score)}</span>}
                {!application.regular && <span className="late-badge">Popunjavanje</span>}
                {!hasTag(rescuer.username, 'tečajac') && !rescuer.coef && <span className="warning-badge">Licenca</span>}
                {!hasTag(rescuer.username, 'tečajac') && !rescuer.membership_paid && <span className="warning-badge">Članarina</span>}
                {rescuer.ski && <span className="ski-info">Skijanje: {rescuer.ski}</span>}
                {!hasTag(rescuer.username, 'tečajac') && !rescuer.ski && <span className="warning-badge">Skijanje</span>}
            </div>
        </div>
        {canEdit && <div className="pending-actions">
            <button className="btn btn-sm btn-success" onClick={() => onConfirm(application)} title="Potvrdi">Ide</button>
            <button className="btn btn-sm btn-danger" onClick={() => onReject(application)} title="Odbij">Ne ide</button>
        </div>}
    </div>

}
